
const apiProxy = require('./apiProxy.js');

module.exports.getPinCode = function(phoneNumber)
{
    return apiProxy.get(`pins/${phoneNumber}`)
            .then(response=>
            {
                return Promise.resolve(response.pin);
            }, error =>
            {
                return Promise.reject(error);
            });
}

module.exports.loadUser = function(phoneNumber)
{
    return apiProxy.get(`customers/${phoneNumber}`);
}

module.exports.loadUserById = function(customerId)
{
    return apiProxy.get(`customers/id/${customerId}`);
}

module.exports.updateUser = function(user)
{
    return apiProxy.post(`customers`, user);
}
